import '_u/vconsole'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Bus from '_u/bus'
import { InputFloat } from './utils/inputFloat'
import { Toast, Button, Col, Row, Cell, CellGroup } from 'vant'
Vue.use(Button).use(Col).use(Row).use(Cell).use(CellGroup)

import store from './store'

Vue.prototype.$toast = Toast
Vue.prototype.$bus = Bus
Vue.config.productionTip = false
// 全局自定义指令 设置输入框最大最小值
Vue.directive('input-float', InputFloat)
// 新的高德地图key需要配合您的安全密钥一起使用
window._AMapSecurityConfig = {
  securityJsCode: '5b37211fb6709e89577730f7dd7e918d'
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
